import keycloak, { reAuth } from "../Keycloak";

export const setSessionCookie = (cookieName: string, cookieValue: string) => {
    document.cookie = `${cookieName}=${cookieValue}; path=/; SameSite=Lax; Secure;`;
}

export const getSessionCookie = (cookieName: string): string | undefined => {
    return document.cookie
        .split("; ")
        .find((row) => row.startsWith(cookieName))
        ?.split("=")[1];
}

export const deleteCookie = (name: string) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

export const sendNativePost = async (endpoint: string, data: object) => {
    const ok = await reAuth(); // Wait for token refresh
    if (!ok) return; // Redirected
    
    const token = keycloak.token
    token && setSessionCookie("JWT_TOKEN", token);

    const form = document.createElement("form");
    form.style.display = 'none';
    form.enctype = 'application/x-www-form-urlencoded';
    form.action = `${window.env.baseURL}/${endpoint}`;
    form.method = 'post';

    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = "json";
    input.value = JSON.stringify(data);
    form.appendChild(input);

    document.body.appendChild(form);
    form.submit();
    form.parentNode?.removeChild(form);
}

export function getEnumKeyByEnumValue<T extends {[index:string]:string}>(myEnum:T, enumValue:string):keyof T|null {
    return Object.keys(myEnum).find(x => myEnum[x] === enumValue) || null;
}